import Cookies from 'universal-cookie';

class CookiesWrapper {
  constructor() {
    this.cookies = new Cookies();
  }

  setCookie(key, value) {
    this.cookies.set(key, value, {
      path: '/',
    });
  }

  getCookie(key) {
    return this.cookies.get(key, {
      path: '/',
    });
  }

  removeCookie(key) {
    this.cookies.remove(key, {
      path: '/',
    });
  }
}

export default new CookiesWrapper();



// WEBPACK FOOTER //
// ./src/common/cookies-wrapper.js